/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The EventsControllerDtoEventStarterPackInfoCreateRequest model module.
 * @module model/EventsControllerDtoEventStarterPackInfoCreateRequest
 * @version 1.0
 */
class EventsControllerDtoEventStarterPackInfoCreateRequest {
    /**
     * Constructs a new <code>EventsControllerDtoEventStarterPackInfoCreateRequest</code>.
     * @alias module:model/EventsControllerDtoEventStarterPackInfoCreateRequest
     */
    constructor() { 
        
        EventsControllerDtoEventStarterPackInfoCreateRequest.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>EventsControllerDtoEventStarterPackInfoCreateRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/EventsControllerDtoEventStarterPackInfoCreateRequest} obj Optional instance to populate.
     * @return {module:model/EventsControllerDtoEventStarterPackInfoCreateRequest} The populated <code>EventsControllerDtoEventStarterPackInfoCreateRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new EventsControllerDtoEventStarterPackInfoCreateRequest();

            if (data.hasOwnProperty('regDuration')) {
                obj['regDuration'] = ApiClient.convertToType(data['regDuration'], 'Number');
            }
            if (data.hasOwnProperty('needUsedPower')) {
                obj['needUsedPower'] = ApiClient.convertToType(data['needUsedPower'], 'Number');
            }
            if (data.hasOwnProperty('beginAt')) {
                obj['beginAt'] = ApiClient.convertToType(data['beginAt'], 'Date');
            }
            if (data.hasOwnProperty('endAt')) {
                obj['endAt'] = ApiClient.convertToType(data['endAt'], 'Date');
            }
            if (data.hasOwnProperty('rewardXper')) {
                obj['rewardXper'] = ApiClient.convertToType(data['rewardXper'], 'Number');
            }
            if (data.hasOwnProperty('rewardItem1')) {
                obj['rewardItem1'] = ApiClient.convertToType(data['rewardItem1'], 'Number');
            }
            if (data.hasOwnProperty('rewardItem1Count')) {
                obj['rewardItem1Count'] = ApiClient.convertToType(data['rewardItem1Count'], 'Number');
            }
            if (data.hasOwnProperty('rewardItem2')) {
                obj['rewardItem2'] = ApiClient.convertToType(data['rewardItem2'], 'Number');
            }
            if (data.hasOwnProperty('rewardItem2Count')) {
                obj['rewardItem2Count'] = ApiClient.convertToType(data['rewardItem2Count'], 'Number');
            }
            if (data.hasOwnProperty('rewardItem3')) {
                obj['rewardItem3'] = ApiClient.convertToType(data['rewardItem3'], 'Number');
            }
            if (data.hasOwnProperty('rewardItem3Count')) {
                obj['rewardItem3Count'] = ApiClient.convertToType(data['rewardItem3Count'], 'Number');
            }
            if (data.hasOwnProperty('createdAt')) {
                obj['createdAt'] = ApiClient.convertToType(data['createdAt'], 'Date');
            }
            if (data.hasOwnProperty('walletNo')) {
                obj['walletNo'] = ApiClient.convertToType(data['walletNo'], 'Number');
            }
            if (data.hasOwnProperty('initialXper')) {
                obj['initialXper'] = ApiClient.convertToType(data['initialXper'], 'Number');
            }
            if (data.hasOwnProperty('depositTransactionStatus')) {
                obj['depositTransactionStatus'] = ApiClient.convertToType(data['depositTransactionStatus'], 'Number');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>EventsControllerDtoEventStarterPackInfoCreateRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>EventsControllerDtoEventStarterPackInfoCreateRequest</code>.
     */
    static validateJSON(data) {

        return true;
    }


}



/**
 * @member {Number} regDuration
 */
EventsControllerDtoEventStarterPackInfoCreateRequest.prototype['regDuration'] = undefined;

/**
 * @member {Number} needUsedPower
 */
EventsControllerDtoEventStarterPackInfoCreateRequest.prototype['needUsedPower'] = undefined;

/**
 * @member {Date} beginAt
 */
EventsControllerDtoEventStarterPackInfoCreateRequest.prototype['beginAt'] = undefined;

/**
 * @member {Date} endAt
 */
EventsControllerDtoEventStarterPackInfoCreateRequest.prototype['endAt'] = undefined;

/**
 * @member {Number} rewardXper
 */
EventsControllerDtoEventStarterPackInfoCreateRequest.prototype['rewardXper'] = undefined;

/**
 * @member {Number} rewardItem1
 */
EventsControllerDtoEventStarterPackInfoCreateRequest.prototype['rewardItem1'] = undefined;

/**
 * @member {Number} rewardItem1Count
 */
EventsControllerDtoEventStarterPackInfoCreateRequest.prototype['rewardItem1Count'] = undefined;

/**
 * @member {Number} rewardItem2
 */
EventsControllerDtoEventStarterPackInfoCreateRequest.prototype['rewardItem2'] = undefined;

/**
 * @member {Number} rewardItem2Count
 */
EventsControllerDtoEventStarterPackInfoCreateRequest.prototype['rewardItem2Count'] = undefined;

/**
 * @member {Number} rewardItem3
 */
EventsControllerDtoEventStarterPackInfoCreateRequest.prototype['rewardItem3'] = undefined;

/**
 * @member {Number} rewardItem3Count
 */
EventsControllerDtoEventStarterPackInfoCreateRequest.prototype['rewardItem3Count'] = undefined;

/**
 * @member {Date} createdAt
 */
EventsControllerDtoEventStarterPackInfoCreateRequest.prototype['createdAt'] = undefined;

/**
 * @member {Number} walletNo
 */
EventsControllerDtoEventStarterPackInfoCreateRequest.prototype['walletNo'] = undefined;

/**
 * @member {Number} initialXper
 */
EventsControllerDtoEventStarterPackInfoCreateRequest.prototype['initialXper'] = undefined;

/**
 * @member {Number} depositTransactionStatus
 */
EventsControllerDtoEventStarterPackInfoCreateRequest.prototype['depositTransactionStatus'] = undefined;






export default EventsControllerDtoEventStarterPackInfoCreateRequest;

